import React from 'react';
import BackGround from 'src/assets/maintenance-bg.svg';
import Icon from 'src/assets/maintenance-icon.svg';
import './MaintenancePage.scss';
const MaintenancePage = () => {
  return (
    <>
      <img src={BackGround} className="maintenance-bg" />
      <div className="maintenance-page-container">
        <div className="maintenance-card">
          <div className="maintenance-content">
            <img src={Icon} className="maintenance-icon" />
            <h1 className="maintenance-title">Maintenance in Progress</h1>
            <p className="maintenance-text">
              The Operator Portal is currently undergoing maintenance. Please check back later. We
              appreciate your patience and understanding.
            </p>
            <p className="maintenance-thank-you">Thank you!</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MaintenancePage;
